import { ReactElement } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Alert, Snackbar } from '@mui/material'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import ResubmitCE from './widgets/resubmit-ce'
import {
  errorMessageChanged,
  selectDashboardChartExpanded,
  selectErrorMessage,
} from '../admin.slice'
import AccessLevelUsers from './widgets/access-level-users'
import AccessLevelLinkedServices from './widgets/access-level-linked-services'
import ExportAllUsers from './widgets/export-all-users'
import ExportQuestionnaires from './widgets/export-questionnaires'
import ExportLiveClassQuestionnaires from './widgets/export-live-class-questionnaires'
import ExportNewJersey from './widgets/new-jersey'

export default (): ReactElement => {
  let dispatch = useAppDispatch()
  let expandedChart = useAppSelector(selectDashboardChartExpanded)
  let errorMessage = useAppSelector(selectErrorMessage)

  return (
    <>
      <Typography variant="h1">Admin Dashboard</Typography>
      <Box className="grid grid-flow-col grid-rows-2 gap-4">
        <Box
          className={expandedChart === 'AccessLevelUsers' ? 'col-span-4' : ''}
        >
          <AccessLevelUsers />
        </Box>
        <Box
          className={
            expandedChart === 'AccessLevelLinkedServices' ? 'col-span-4' : ''
          }
        >
          <AccessLevelLinkedServices />
        </Box>
        <ExportAllUsers />
        <ResubmitCE />
        <ExportQuestionnaires />
        <ExportLiveClassQuestionnaires />
        <ExportNewJersey />
      </Box>
      <Snackbar
        open={!!errorMessage}
        onClose={() => dispatch(errorMessageChanged(''))}
      >
        <Alert
          variant="filled"
          onClose={() => dispatch(errorMessageChanged(''))}
          severity="error"
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  )
}
